// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__384nC","icon":"SortAdornment_icon__7kr5-","up":"SortAdornment_up__303oC","down":"SortAdornment_down__2J_hk","active":"SortAdornment_active__ROLla"};